module.exports = __webpack_public_path__ + "img/zry.72ca430a.jpg";